import db from "../../database";
import * as msg from "../../message";
import * as helper from "../../helper";
import store from "../../store/index";
import { Object } from "core-js";
const moment = require("moment");

export const openSession = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE: OPEN SESSION]");
    let response = {
      data: {},
    };
    let session_id = 0;
    // let online_session_id = 0;

    if (store.state.system.isOffline == false) {
      let insertData = {
        vu_id: data.data.data.vu_id,
        trans_from: "CLOUD_TAB_WEB",
        settlement_date: data.data.data.settlement_date,
        opening_time: data.data.data.opening_time,
        opening_balance: data.data.data.opening_balance,
        closing_time: null,
        closing_balance: null,
        online_session_id: data.data.data.id,
        sync: 1,
      };
      let config = data.data.data;
      db.transaction("rw", db.session, db.setting, db.cart, async () => {
        await db.session.put(insertData);

        let settings = store.state.system.settings;
        settings.settlement.opening_balance_status = 1;
        settings.settlement.session_started_at = insertData.opening_time;

        let update = {
          session_id: config.id,
        };

        await db.setting
          .where("user_id")
          .equals(parseInt(config.vu_id))
          .modify({
            settings: settings,
          });

        await db.cart
          .where("[store_id+vu_id+v_id]")
          .equals([
            parseInt(config.store_id),
            parseInt(config.vu_id),
            parseInt(config.v_id),
          ])
          .each(async (item) => {
            if (item != undefined) {
              await db.cart.update(item.id, update);
            }
          });
      });
      return Promise.resolve(response);
    }

    let insertData = {
      vu_id: data.vu_id,
      trans_from: "CLOUD_TAB_WEB",
      settlement_date: data.settlement_date,
      opening_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      opening_balance: data.opening_balance,
      closing_time: null,
      closing_balance: null,
      online_session_id: 0,
      sync: 0,
    };

    db.transaction("rw", db.session, db.setting, db.cart, async () => {
      let settings = store.state.system.settings;
      settings.settlement.opening_balance_status = 1;
      settings.settlement.session_started_at = insertData.opening_time;

      console.log("cool");

      await db.setting
        .where("user_id")
        .equals(parseInt(data.vu_id))
        .modify({
          settings: settings,
        });

      await db.session.put(insertData);
      response.data = {
        data: {
          opening_time: insertData.opening_time,
        },
      };

      await db.session
        .where("vu_id")
        .equals(parseInt(data.vu_id))
        .and((filter) => {
          return filter.closing_balance == "";
        })
        .first((item) => {
          if (item != undefined) {
            session_id = item.id;
          }
        });

      await db.cart
        .where("[store_id+vu_id+v_id]")
        .equals([
          parseInt(data.store_id),
          parseInt(data.vu_id),
          parseInt(data.v_id),
        ])
        .and((filter) => {
          return filter.status == "process";
        })
        .each(async (item) => {
          if (item != undefined) {
            await db.cart.update(item.id, { session_id: config.id });
          }
        });

      response.data.status = "success";
    })
      .then(() => {
        store.dispatch("system/log", {
          type: "open_session",
          log: { sessionId: session_id },
          response: response,
          status: "success",
        });
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "open_session",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const closeSession = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Close Session");
    let response = {
      data: {},
    };

    let closing_time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

    if (store.state.system.isOffline == false) {
      let config = JSON.parse(data.config.data);
      db.transaction("rw", db.setting, db.session, db.cart, async () => {
        let update = {
          closing_time: closing_time,
          closing_balance: config.closing_balance,
        };
        await db.session
          .where("online_session_id")
          .equals(parseInt(store.state.sessions.session.id))
          .first(async (item) => {
            if (item != undefined) {
              await db.session.update(item.id, update);
            }
          });

        let settings = store.state.system.settings;
        settings.settlement.opening_balance_status = 0;
        settings.settlement.closing_previous_balance_status = 1;
        settings.settlement.session_started_at = "";

        await db.setting
          .where("user_id")
          .equals(parseInt(config.vu_id))
          .modify({
            settings: settings,
          });
        await db.cart
          .where("[store_id+vu_id+v_id]")
          .equals([
            parseInt(config.store_id),
            parseInt(config.vu_id),
            parseInt(config.v_id),
          ])
          .each(async (item) => {
            if (item != undefined) {
              let update = {
                session_id: 0,
              };
              await db.cart.update(item.id, update);
            }
          });
      });
      return Promise.resolve(response);
    }

    db.transaction("rw", db.session, db.setting, async () => {
      await db.session
        .where("vu_id")
        .equals(parseInt(data.vu_id))
        .and((filter) => {
          return filter.closing_balance == "" || filter.closing_balance == null;
        })
        .modify({
          closing_balance: data.closing_balance,
          closing_time: closing_time,
        });

      let settings = store.state.system.settings;
      settings.settlement.opening_balance_status = 0;
      settings.settlement.closing_previous_balance_status = 1;
      settings.settlement.session_started_at = "";

      await db.setting
        .where("user_id")
        .equals(parseInt(data.vu_id))
        .modify({
          settings: settings,
        });

      response.data.status = "success";
    })
      .then(() => {
        let productData = {
          barcode: "",
          url: "remove-product-from-cart",
          product_id: "",
          cart_id: "",
          all: "1",
        };
        let data = Object.assign(
          productData,
          store.getters["sessions/getEssentialsData"],
          store.getters["sessions/getCustomerParam"]
        );
        store.dispatch("billing/cancelBill", data);
        store.dispatch("system/log", {
          type: "close_session",
          log: {},
          response: response,
          status: "success",
        });
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "close_session",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

function alertData() {
  let alertData = {
    message: msg.INTERNAL_SERVER_ERROR,
    type: "danger",
  };
  store.commit("notifications/showAlert", alertData);
}
